import { Component } from 'react';

/**
 * ErrorBoundary — a render error below it shows `fallback` in its place instead of taking the
 * whole app down (React unmounts everything up to the nearest boundary, and the portal had none).
 *
 *   fallback   a node, or ({ error, reset }) => node; reset() renders the children again
 *   resetKey   when it changes (the route, the session id), a shown error is cleared
 *
 * React itself reports the caught error to the console.
 */
export default class ErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidUpdate(prev) {
        if (this.state.error && prev.resetKey !== this.props.resetKey) this.reset();
    }

    reset = () => this.setState({ error: null });

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;
        const { fallback } = this.props;
        return typeof fallback === 'function' ? fallback({ error, reset: this.reset }) : (fallback ?? null);
    }
}
